module.exports = __webpack_public_path__ + "static/media/mightycoder.a13311a3.svg";